<script setup lang="ts">
import { UiButtonVariant } from '@afs/design-system'

import type { PreviewsListProps, PreviewListEvents } from './interface'
import { useI18n } from 'vue-i18n'

defineProps<PreviewsListProps>()
defineEmits<PreviewListEvents>()

const { t } = useI18n()
</script>

<template>
  <div class="PreviewsList">
    <h2 class="heading-2 color-blue-01">{{ title }}</h2>
    <ul>
      <li
        v-for="(article, index) in articles"
        :key="article.id"
        class="PreviewsList__item"
        :class="{ 'mb-4 pb-4': index < articles.length - 1 }"
      >
        <molecules-ui-preview v-bind="article" />
      </li>
    </ul>
    <div class="PreviewsList__bottom">
      <atoms-ui-button
        v-if="showMoreBtn"
        :text="t('advices.showMore.label')"
        :variant="UiButtonVariant.OUTLINE"
        class="mb-3"
        @click="$emit('previewsList::loadMore')"
      />
      <p class="paragraph-4 color-blue-01">
        {{ t('advices.showMore.on', { articlesCount: articles.length, totalCount: count }) }}
      </p>
    </div>
  </div>
</template>

<style lang="scss" scoped>
@use 'sass:map';
@use 'config/spaces';
@use 'config/colors';
@use 'utilities/mq';

.PreviewsList {
  display: flex;
  flex-direction: column;
  gap: map.get(spaces.$sizes, '5');

  @include mq.media('>=medium') {
    gap: map.get(spaces.$sizes, '6');
  }
}

.PreviewsList__item {
  &:not(:last-of-type) {
    border-bottom: 2px solid map.get(colors.$blue, '03');
  }
}

.PreviewsList__bottom {
  text-align: center;
}
</style>
